function compareFieldValidator(command: any, ctxData: any, keys: string[] = Object.keys(command)): boolean {
  return keys.every(key => {
    if(command.hasOwnProperty(key) && ctxData.hasOwnProperty(key)) {
      if(typeof command[key] === 'object' && typeof ctxData[key] === 'object') {
        return JSON.stringify(command[key]) === JSON.stringify(ctxData[key]);
      }
      else {
        return command[key] === ctxData[key];
      }
    } else{
      return false;
    }
  });
}

export function defaultCommandValidator<TCommand>(command: TCommand, ctxData: any): boolean {
  return compareFieldValidator(command, ctxData);
}
